module.exports = __webpack_public_path__ + "static/img/4.62fb67e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/4.jpg
// module id = 1Yt3
// module chunks = 5